import React, { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CreatableSelect from 'react-select/creatable';
import {
    Modal, Button, Badge, Card, Row, Col,
    Container, Spinner, ButtonGroup,
    ToggleButton, Form, Dropdown, InputGroup
} from 'react-bootstrap';
import { api } from '../../services/api.js';
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer/index.jsx';
import Foto from "../Components/Foto";
import PdfFullscreen from "../Components/Foto/pdf.jsx";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './atendimento.css';

const chapa = localStorage.getItem("chapa");

function AtendimentoTecnico() {
    const [chamados, setChamados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtroStatus, setFiltroStatus] = useState('Pendentes');
    const [setorSelecionado, setSetorSelecionado] = useState("");
    const [anexosAbertura, setAnexosAbertura] = useState([]);
    const [fotoSelecionada, setFotoSelecionada] = useState(null);
    const [pdfSelecionado, setPdfSelecionado] = useState(null);
    const [statusSetor, setStatusSetor] = useState([]);
    const [statusSelecionado, setStatusSelecionado] = useState(null);
    const chatContainerRef = useRef(null);
    const [urlParaVisualizar, setUrlParaVisualizar] = useState("");
    const navigate = useNavigate();
    const [segundosParaAtualizar, setSegundosParaAtualizar] = useState(180); // 180s = 3 min
    const [lojasSelecionadas, setLojasSelecionadas] = useState(() => {
        const salvo = localStorage.getItem("@Arbor:filtroLojas");
        return salvo ? JSON.parse(salvo) : [];
    });
    const [modoSomenteLeitura, setModoSomenteLeitura] = useState(false);

    const removerAnexo = (indexParaRemover) => {
        setAnexosNovos(prev => prev.filter((_, index) => index !== indexParaRemover));
    };
    const [fullscreenPdf, setFullscreenPdf] = useState(false);

    const [setoresPermitidosFormatados, setSetoresPermitidosFormatados] = useState([]);
    const [categoriasSetor, setCategoriasSetor] = useState([]); // Nova state

    const [showDetalhes, setShowDetalhes] = useState(false);
    const [chamadoSelecionado, setChamadoSelecionado] = useState(null);
    const [interacoes, setInteracoes] = useState([]);
    const [loadingDetalhes, setLoadingDetalhes] = useState(false);

    const [novaMsg, setNovaMsg] = useState("");
    const [anexosNovos, setAnexosNovos] = useState([]);
    const [enviandoInt, setEnviandoInt] = useState(false);
    const [atualizandoCategoria, setAtualizandoCategoria] = useState(false); // Novo loading
    const fileInputRef = useRef(null);
    const MySwal = withReactContent(Swal);
    const [showDropdown, setShowDropdown] = useState(false);
    const [pdfUrl, setPdfUrl] = useState("");


    //paginação
    const [pagina, setPagina] = useState(1);
    const [temMais, setTemMais] = useState(true);

    const formatarNomePrimeiro = (nome) => {
        if (!nome) return "";
        const primeiro = nome.split(" ")[0].toLowerCase();
        return primeiro.charAt(0).toUpperCase() + primeiro.slice(1);
    };

    const decodeBase64 = (str) => {
        try {
            if (!str || typeof str !== "string") return "";
            let base64 = str.replace(/\s/g, "");
            const binary = window.atob(base64);
            const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
            try {
                return new TextDecoder("utf-8", { fatal: true }).decode(bytes);
            } catch (e) {
                return new TextDecoder("iso-8859-1").decode(bytes);
            }
        } catch (e) { return str; }
    };

    const handlePaste = (e) => {
        const items = e.clipboardData.items;

        let temImagem = false;

        for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf("image") !== -1) {
                temImagem = true;

                const blob = items[i].getAsFile();
                const file = new File([blob], `print_${Date.now()}.png`, { type: blob.type });

                const reader = new FileReader();
                reader.onloadend = () => {
                    setAnexosNovos(prev => [
                        ...prev,
                        {
                            nome: file.name,
                            base64: reader.result.split(',')[1]
                        }
                    ]);
                };

                reader.readAsDataURL(file);
            }
        }

        if (temImagem) {
            e.preventDefault(); // 🔥 evita colar no campo
            toast.info("📸 Print anexado automaticamente!");
        }
    };

    const handleSubmitInteracao = async () => {
        const statusOriginal = chamadoSelecionado.status;
        const mensagemFinal = novaMsg.trim();

        // Validação de mensagem (opcional, dependendo da sua regra)
        if (!mensagemFinal && statusSelecionado === statusOriginal) {
            toast.warning("Digite uma mensagem para enviar.");
            return;
        }

        // Se o técnico mudou o status no Dropdown, perguntamos
        if (Number(statusSelecionado) !== Number(statusOriginal)) {
            const resultado = await MySwal.fire({
                title: 'Alterar Status?',
                text: `Você selecionou um novo status. Deseja aplicar essa alteração ao enviar?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim, alterar e enviar',
                cancelButtonText: 'Não, manter status atual'
            });

            if (resultado.isConfirmed) {
                realizarAcao(statusSelecionado);
            } else if (resultado.dismiss === Swal.DismissReason.cancel) {
                // Se ele cancelar, enviamos com o status original
                realizarAcao(statusOriginal);
            }
        } else {
            // Se não alterou nada, envia com o status que já estava
            realizarAcao(statusOriginal);
        }
    };

    {/*useEffect(() => {
        if (pdfSelecionado?.base64) {
            // Remove o prefixo se existir
            const base64Limpo = pdfSelecionado.base64.includes(',')
                ? pdfSelecionado.base64.split(',')[1]
                : pdfSelecionado.base64;

            try {
                const byteCharacters = atob(base64Limpo);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' });

                const url = URL.createObjectURL(blob);
                setPdfUrl(url);

                // Limpa a memória quando fechar o PDF
                return () => {
                    URL.revokeObjectURL(url);
                };
            } catch (e) {
                console.error("Erro ao converter PDF", e);
            }
        } else {
            setPdfUrl("");
        }
    }, [pdfSelecionado]);*/}
    // No AtendimentoTecnico.jsx
    useEffect(() => {
        if (pdfSelecionado?.base64) {
            const base64Limpo = pdfSelecionado.base64.split(',')[1] || pdfSelecionado.base64;
            try {
                const byteCharacters = atob(base64Limpo);
                const byteNumbers = new Uint8Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const nomeArquivo = (pdfSelecionado.nome || "").toLowerCase();

                const isTxt =
                    nomeArquivo.endsWith('.txt') ||
                    nomeArquivo.endsWith('.txt_conv');

                const tipoMime = isTxt ? 'text/plain' : 'application/pdf';

                const blob = new Blob([byteNumbers], { type: tipoMime });
                const url = URL.createObjectURL(blob);

                setUrlParaVisualizar(url);

                return () => URL.revokeObjectURL(url);
            } catch (e) {
                console.error("Erro ao converter anexo:", e);
            }
        }
    }, [pdfSelecionado]);


    const baixarArquivo = (anexo) => {
        const base64Limpo = anexo.base64.includes(',')
            ? anexo.base64.split(',')[1]
            : anexo.base64;

        const byteCharacters = atob(base64Limpo);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        const nome = (anexo.nome || "").toLowerCase();

        const isTxt =
            nome.endsWith('.txt') ||
            nome.endsWith('.txt_conv');

        const blob = new Blob([byteArray], {
            type: isTxt ? 'text/plain' : 'application/pdf'
        });

        const extensao = isTxt ? '.txt' : '.pdf';

        const nomeDownload = `CHAMADO_${chamadoSelecionado?.ID_CHAMADO || 'ANEXO'}_${anexo.nome || 'ARQUIVO'}${extensao}`;

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = nomeDownload;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    useEffect(() => {
        async function carregarSetores() {
            try {
                // Recupera as permissões do localStorage
                const permissõesLocalStorage = JSON.parse(localStorage.getItem("setorchamado") || "[]");

                // 2. Trava imediata: Se não houver nada no localStorage, bloqueia
                if (permissõesLocalStorage.length === 0) {
                    await Swal.fire({
                        icon: 'error',
                        title: 'Acesso Negado',
                        text: 'O Usuário não tem permissão para acessar este módulo.',
                        confirmButtonColor: '#d33'
                    });
                    navigate('/arbor/home');
                    return;
                }

                const codigosPermitidos = permissõesLocalStorage.map(c => String(c));
                const res = await api.get('/chamados/setores');
                const todosSetores = res.data || [];

                const filtrados = todosSetores.filter(s =>
                    codigosPermitidos.includes(String(s.id_setor || s.codigo))
                );

                // 3. Trava secundária: Se após filtrar a API não sobrar nenhum setor válido
                if (filtrados.length === 0) {
                    await Swal.fire({
                        icon: 'warning',
                        title: 'Permissão Inválida',
                        text: 'Nenhum setor vinculado às suas permissões foi encontrado.',
                        confirmButtonColor: '#3085d6'
                    });
                    navigate('/arbor/home');
                    return;
                }

                setSetoresPermitidosFormatados(filtrados);

                if (filtrados.length > 0 && !setorSelecionado) {
                    const idPadrao = filtrados[0].id_setor || filtrados[0].codigo;
                    setSetorSelecionado(String(idPadrao));
                }
            } catch (err) {
                console.error(err);
                toast.error("Erro ao carregar lista de setores");
            }
        }
        carregarSetores();
    }, [setorSelecionado, navigate]); // Adicionado navigate nas dependências

    useEffect(() => {
        localStorage.setItem("@Arbor:filtroLojas", JSON.stringify(lojasSelecionadas));
    }, [lojasSelecionadas]);

    // Busca categorias sempre que o setor mudar
    useEffect(() => {
        if (setorSelecionado) {

            api.get(`/chamados/categorias?setor=${setorSelecionado}`)
                .then(res => setCategoriasSetor(res.data || []))
                .catch(() => toast.error("Erro ao carregar categorias"));
        }
    }, [setorSelecionado]);

    useEffect(() => {
        if (chatContainerRef.current) {
            const container = chatContainerRef.current;
            container.scrollTo({
                top: container.scrollHeight,
                behavior: "smooth" // "smooth" para deslizar, "auto" para ir instantâneo
            });
        }
    }, [interacoes]); // Executa sempre que a lista de interações for atualizada

    useEffect(() => {
        if (setorSelecionado) {
            api.get(`/chamados/status?setor=${setorSelecionado}`)
                .then(
                    res => setStatusSetor(res.data || [])
                )
                .catch(() => toast.error("Erro ao carregar status do setor"));
        };
    }, [setorSelecionado]);

    useEffect(() => {
        console.log("STATUS SETOR ATUALIZADO:", statusSetor);
    }, [statusSetor]);

    // 1. Ajuste na função carregarChamados
    {/*const carregarChamados = useCallback(async (silencioso = false) => {
        if (!setorSelecionado) return;

        // Só ativa o loading se não for uma atualização silenciosa
        if (!silencioso) setLoading(true);


        try {
            let st = -1;
            let usr = "";
            if (filtroStatus === "Pendentes") {
                st = 0;
                usr = "T";
            } else if (filtroStatus === "Aguardando Usuário") {
                usr = "U";
            } else if (filtroStatus === "Aguardando Avaliação") {
                st = 90;
                usr = "X";
            } else if (filtroStatus === "Encerrados") {
                st = 99;
                usr = "X";
            }
            const filtroLojasStr = lojasSelecionadas.map(l => l.value).join(',');
            const res = await api.get(`/chamados`, {
                params: {
                    depend: usr,
                    loja: -1,
                    usuario: '',
                    status: st,
                    setor: setorSelecionado,
                    filtroLojas: filtroLojasStr // 🔥 Passa a string "2,3,10"
                }
            });
            const dados = res.data || [];
            setChamados(dados);
        } catch (err) {
            // No erro, avisamos apenas se não for silencioso para não interromper o técnico
            if (!silencioso) toast.error("Erro ao carregar chamados");
        } finally {
            if (!silencioso) setLoading(false);
        }
    }, [setorSelecionado, filtroStatus, lojasSelecionadas]);*/}

    const carregandoRef = useRef(false);
    const requestIdRef = useRef(0);


    const LIMITE = 15; // ou 10

    const carregarChamados = useCallback(async (novaPagina = 1) => {
        if (!setorSelecionado) return;
        if (carregandoRef.current) return;

        carregandoRef.current = true;
        setLoading(true);

        // 🔥 MELHORIA: Se for a página 1, limpa os chamados atuais na hora 
        // para o usuário ver o Spinner e depois a lista filtrada correta.
        if (novaPagina === 1) {
            setChamados([]);
        }

        try {
            let st = -1;
            let usr = "";
            if (filtroStatus === "Pendentes") {
                st = 0;
                usr = "T";
            } else if (filtroStatus === "Aguardando Usuário") {
                usr = "U";
            } else if (filtroStatus === "Aguardando Avaliação") {
                st = 90;
                usr = "X";
            } else if (filtroStatus === "Encerrados") {
                st = 99;
                usr = "X";
            }

            const filtroLojasStr = lojasSelecionadas.map(l => l.value).join(',');

            const res = await api.get(`/chamados`, {
                params: {
                    depend: usr,
                    loja: -1,
                    usuario: '',
                    status: st,
                    setor: setorSelecionado,
                    filtroLojas: filtroLojasStr,
                    pagina: novaPagina,
                    limite: LIMITE // Use um valor maior aqui se quiser mais itens por vez, ex: 10 ou 20
                }
            });

            const dados = res.data || [];

            if (novaPagina === 1) {
                setChamados(dados); // Substitui pelo resultado do filtro
            } else {
                setChamados(prev => [...prev, ...dados]); // Concatena paginação
            }

            setTemMais(dados.length === LIMITE);
            setPagina(novaPagina);

        } catch (err) {
            console.error(err);
            toast.error("Erro ao carregar chamados");
        } finally {
            carregandoRef.current = false;
            setLoading(false);
        }
    }, [setorSelecionado, filtroStatus, lojasSelecionadas, LIMITE]);

    // 1. Carregar sempre que mudar o filtro (Reseta para página 1)
    useEffect(() => {
        if (setorSelecionado) {
            carregarChamados(1); // Busca a página 1 e substitui a lista atual
        }
    }, [setorSelecionado, filtroStatus, lojasSelecionadas]);

    // 2. Timer de atualização automática (Atualização Silenciosa)
    useEffect(() => {
        if (setorSelecionado) {
            const intervalo = setInterval(() => {
                setSegundosParaAtualizar((prev) => {
                    if (prev <= 1) {
                        carregarChamados(1); // Atualiza a lista
                        return 180; // Reinicia o timer
                    }
                    return prev - 1;
                });
            }, 1000); // Roda a cada 1 segundo

            return () => clearInterval(intervalo);
        }
    }, [setorSelecionado, carregarChamados]);

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        files.forEach(file => {
            const reader = new FileReader();
            reader.onloadend = () => {
                setAnexosNovos(prev => [...prev, {
                    nome: file.name,
                    base64: reader.result.split(',')[1]
                }]);
            };
            reader.readAsDataURL(file);
        });
        // Limpa o input para permitir selecionar o mesmo arquivo se for removido
        e.target.value = null;
    };

    // 1. Cria a função para validar no servidor antes de abrir
    const tentarAssumirEAbrir = async (chamado) => {
        try {
            // Chapa é o que você já pega do localStorage no topo do arquivo
            const res = await api.post('/chamados/assumir', {
                id: chamado.ID_CHAMADO,
                usuario: chapa
            });

            if (res.data.status === 'ocupado') {
                // Se já tiver alguém, avisa mas permite continuar (conforme solicitado)
                Swal.fire({
                    title: 'Chamado em Atendimento',
                    text: `Este chamado já está sendo atendido por ${res.data.tecnico}. Deseja continuar?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sim, continuar',
                    cancelButtonText: 'Cancelar',
                    confirmButtonColor: '#ffc107'
                }).then((result) => {
                    if (result.isConfirmed) {
                        setChamadoSelecionado(chamado);
                        setShowDetalhes(true);
                    }
                });
            } else {
                // Se estiver livre, o backend já registrou você, agora é só abrir
                setChamadoSelecionado(chamado);
                setShowDetalhes(true);
            }
        } catch (err) {
            toast.error("Erro ao validar status do atendimento.");
            // Em caso de erro na API, abre por segurança para não travar o técnico
            setChamadoSelecionado(chamado);
            setShowDetalhes(true);
        }
    };


    {/*const abrirDetalhes = async (chamado) => {
        setChamadoSelecionado(chamado);
        setStatusSelecionado(chamado.status);
        setShowDetalhes(true);
        setLoadingDetalhes(true);
        setAnexosAbertura([]);

        const id = chamado.id_chamado;

        try {
            const resInt = await api.get(`/chamado/${id}/interacoes`);
            const listaInteracoes = resInt.data || [];

            const interacoesComAnexos = await Promise.all(
                listaInteracoes.map(async (i) => {
                    try {
                        const idInteracao = i.id_interacao || i.ID_INTERACAO;
                        const resAnexo = await api.get(`/chamado/anexos?id=${id}&id_interacao=${idInteracao}`);
                        return { ...i, ANEXOS: resAnexo.data || [] };
                    } catch {
                        return { ...i, ANEXOS: [] };
                    }
                })
            );

            const resAnexosAbertura = await api.get(`/chamado/anexos?id=${id}&id_interacao=0`);

            setInteracoes(interacoesComAnexos);
            setAnexosAbertura(resAnexosAbertura.data || []);
        } catch (err) {
            toast.error("Erro ao carregar histórico completo");
        } finally {
            setLoadingDetalhes(false);
        }
    };*/}

    const abrirDetalhes = async (chamado) => {
        let somenteLeitura = false;

        // 1. Perguntar se vai iniciar o atendimento ou apenas consultar
        const resultIntencao = await Swal.fire({
            title: 'Acesso ao Chamado',
            text: "Você irá iniciar o atendimento deste chamado agora?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, iniciar atendimento',
            cancelButtonText: 'Apenas consultar',
            confirmButtonColor: '#198754', // Verde
            cancelButtonColor: '#6c757d',  // Cinza
        });

        if (resultIntencao.isConfirmed) {
            // Tenta assumir o chamado no banco
            try {
                const resAssumir = await api.post('/chamados/assumir', {
                    id: chamado.id_chamado || chamado.ID_CHAMADO,
                    usuario: chapa
                });

                if (resAssumir.data.status === 'ocupado') {
                    const resultOcupado = await Swal.fire({
                        title: 'Chamado Ocupado',
                        text: `O técnico ${resAssumir.data.tecnico} já está atendendo. Abrir apenas para consulta?`,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Sim, consultar',
                        cancelButtonText: 'Cancelar'
                    });

                    if (!resultOcupado.isConfirmed) return;
                    somenteLeitura = true; // Entra como consulta pois já tem dono
                }
            } catch (err) {
                console.error("Erro ao assumir chamado:", err);
            }
        } else if (resultIntencao.dismiss === Swal.DismissReason.cancel) {
            // Clicou em "Apenas consultar"
            somenteLeitura = true;
        } else {
            // Clicou fora ou fechou o modal do Swal
            return;
        }

        // 2. Configura os estados e carrega os dados
        setModoSomenteLeitura(somenteLeitura);
        setChamadoSelecionado(chamado);
        setStatusSelecionado(chamado.status || chamado.STATUS);
        setShowDetalhes(true);
        setLoadingDetalhes(true);

        const id = chamado.id_chamado || chamado.ID_CHAMADO;
        try {
            const resInt = await api.get(`/chamado/${id}/interacoes`);
            const listaInteracoes = resInt.data || [];

            const interacoesComAnexos = await Promise.all(
                listaInteracoes.map(async (i) => {
                    try {
                        const idInteracao = i.id_interacao || i.ID_INTERACAO;
                        const resAnexo = await api.get(`/chamado/anexos?id=${id}&id_interacao=${idInteracao}`);
                        return { ...i, ANEXOS: resAnexo.data || [] };
                    } catch {
                        return { ...i, ANEXOS: [] };
                    }
                })
            );

            const resAnexosAbertura = await api.get(`/chamado/anexos?id=${id}&id_interacao=0`);
            setInteracoes(interacoesComAnexos);
            setAnexosAbertura(resAnexosAbertura.data || []);
        } catch (err) {
            toast.error("Erro ao carregar dados");
        } finally {
            setLoadingDetalhes(false);
        }
    };

    const alterarCategoria = async (idNovaCat, nomeNovaCat) => {
        // Substituindo window.confirm pelo SweetAlert2
        const resultado = await MySwal.fire({
            title: 'Confirmar Alteração?',
            text: `Deseja alterar a categoria para: ${nomeNovaCat}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, alterar!',
            cancelButtonText: 'Cancelar'
        });

        if (resultado.isConfirmed) {
            setAtualizandoCategoria(true);
            try {
                await api.put('/chamado/categoria', {
                    id_chamado: chamadoSelecionado.id_chamado,
                    id_nova_categoria: idNovaCat,
                    usuario: chapa,
                    categoria_antiga_nome: chamadoSelecionado.nome_categoria || chamadoSelecionado.categoria_nome,
                    nova_categoria_nome: nomeNovaCat
                });

                MySwal.fire({
                    title: 'Sucesso!',
                    text: 'Categoria atualizada e histórico registrado.',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });

                // Atualiza localmente
                setChamadoSelecionado(prev => ({ ...prev, id_categoria: idNovaCat, nome_categoria: nomeNovaCat }));

                // Recarrega detalhes para ver a nova interação no chat
                abrirDetalhes({ ...chamadoSelecionado, id_categoria: idNovaCat, nome_categoria: nomeNovaCat });
            } catch (err) {
                MySwal.fire('Erro', 'Não foi possível alterar a categoria.', 'error');
            } finally {
                setAtualizandoCategoria(false);
            }
        } else {
            // Se o usuário cancelar, resetamos o select para o valor anterior (opcional)
            carregarChamados();
        }
    };

    const realizarAcao = async (novoStatus, msgPadrao = "") => {
        const id = chamadoSelecionado.id_chamado;
        const mensagemFinal = novaMsg.trim() || msgPadrao;

        if (!mensagemFinal && novoStatus !== 1) {
            toast.warning("Por favor, escreva uma mensagem ou parecer.");
            return;
        }

        setEnviandoInt(true);
        try {
            await api.post('/interacao', {
                id_chamado: id,
                usuario: chapa,
                perfil: 'TECNICO',
                mensagem: mensagemFinal,
                status_novo: novoStatus,
                anexos: anexosNovos.map(a => ({
                    nome: a.nome || a.NOME_ARQUIVO || 'arquivo',
                    base64: a.base64 || a.BASE64
                }))
            });

            // 1. Notificação de Sucesso com SweetAlert
            await MySwal.fire({
                icon: 'success',
                title: 'Sucesso!',
                text: 'Operação realizada com sucesso.',
                timer: 2000,
                showConfirmButton: false
            });

            // 2. Limpa os campos de texto e anexos
            setNovaMsg("");
            setAnexosNovos([]);

            // 3. ATUALIZAÇÃO: Chama 'abrirDetalhes' para recarregar o chat sem fechar o modal
            // Passamos o chamado selecionado atual para manter os dados na tela
            await abrirDetalhes(chamadoSelecionado);

            // 4. Atualiza a lista de chamados (a grade que fica ao fundo)
            carregarChamados();

            // 5. Scroll automático para o final das mensagens
            setTimeout(() => {
                const container = document.getElementById('chat-container');
                if (container) {
                    container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
                }
            }, 300);

        } catch (err) {
            console.error(err);
            toast.error("Erro ao processar solicitação");
        } finally {
            setEnviandoInt(false);
        }
    };


    const renderAnexos = (lista) => (
        <Row className="g-1 mt-2">
            {lista.map((f, idx) => {
                const nome = (f.NOME_ARQUIVO || f.nome || "").toLowerCase();
                const base64 = (f.BASE64 || f.base64);

                const isPdf = nome.endsWith('.pdf');

                const isTxt =
                    nome.endsWith('.txt') ||
                    nome.endsWith('.txt_conv');

                return (
                    <Col xs={4} key={idx}>
                        <div
                            className="ratio ratio-1x1 border rounded overflow-hidden bg-light d-flex align-items-center justify-content-center"
                            style={{ cursor: 'pointer', minWidth: '60px' }}
                            onClick={() => {
                                if (isPdf || isTxt) {
                                    setPdfSelecionado({ nome, base64 });
                                } else {
                                    setFotoSelecionada({
                                        foto: `data:image/jpeg;base64,${base64}`,
                                        nome
                                    });
                                }
                            }}
                        >
                            {isPdf ? (
                                <div className="text-center">
                                    <i className="bi bi-file-pdf text-danger" style={{ fontSize: '1.5rem' }}></i>
                                    <div style={{ fontSize: '8px' }}>PDF</div>
                                </div>
                            ) : isTxt ? (
                                <div className="text-center">
                                    <i className="bi bi-file-earmark-text text-primary" style={{ fontSize: '1.5rem' }}></i>
                                    <div style={{ fontSize: '8px' }}>TXT</div>
                                </div>
                            ) : (
                                <img
                                    src={`data:image/jpeg;base64,${base64}`}
                                    alt="anexo"
                                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                                />
                            )}
                        </div>
                    </Col>
                );
            })}
        </Row>
    );

    const formatarData = (s) => s ? new Date(s.replace("Z", "")).toLocaleString('pt-BR') : "";
    const formatarHora = (s) => s ? new Date(s.replace("Z", "")).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : "";

    return (
        <div style={{ paddingTop: '80px', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Menu modulo="ARBOR" />
            <Container>
                <div className="mb-4">
                    {/* Título e Seletor de Setor sempre alinhados no topo */}
                    <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                        <h4 className="fw-bold mb-0">Central Técnica</h4>

                        <Form.Group className="d-flex align-items-center gap-2">
                            <span className="small fw-bold">Setor:</span>
                            <Form.Select
                                size="sm"
                                style={{ width: '180px' }} // Ajustado levemente para caber melhor em telas menores
                                value={setorSelecionado}
                                onChange={(e) => setSetorSelecionado(e.target.value)}
                            >
                                {setoresPermitidosFormatados.map((s, idx) => (
                                    <option key={idx} value={s.id_setor || s.codigo}>
                                        {s.nome_setor || s.descricao}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </div>

                    {/* Filtro de Lojas: No desktop ocupa parte da largura, no mobile ocupa 100% */}
                    <Row>
                        <Col xs={12} md={6} lg={5}>
                            <CreatableSelect
                                isMulti
                                placeholder="Filtrar lojas (ex: 02, 05...)"
                                value={lojasSelecionadas}
                                onChange={(newValue) => setLojasSelecionadas(newValue)}
                                onCreateOption={(inputValue) => {
                                    const formatada = inputValue.trim().padStart(2, '0');
                                    const newOption = { label: formatada, value: parseInt(formatada) };
                                    setLojasSelecionadas((prev) => [...prev, newOption]);
                                }}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                noOptionsMessage={() => "Digite a loja e dê Enter"}
                                formatCreateLabel={(inputValue) => `Adicionar loja ${inputValue.padStart(2, '0')}`}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: '38px',
                                        border: '1px solid #dee2e6',
                                        borderRadius: '8px'
                                    })
                                }}
                            />
                        </Col>
                    </Row>
                </div>


                <div className="status-container-scroll w-100">
                    <ButtonGroup size="sm" className="bg-white shadow-sm rounded-pill p-1">
                        {["Pendentes", "Aguardando Usuário", "Aguardando Avaliação", "Encerrados"].map((st) => (
                            <ToggleButton
                                key={st}
                                type="radio"
                                variant={filtroStatus === st ? "primary" : "outline-white"}
                                className={`border-0 rounded-pill px-4 ${filtroStatus === st ? 'text-white' : 'text-dark'}`}
                                onClick={() => setFiltroStatus(st)}
                            >
                                {st}
                            </ToggleButton>
                        ))}
                    </ButtonGroup>
                </div>
                {/* 1. Spinner central: só aparece se estiver carregando e a lista estiver VAZIA (primeira carga) */}
                {loading && chamados.length === 0 && (
                    <div className="text-center mt-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                )}

                {/* 2. A Row da lista fica sempre visível para não perder a posição do scroll */}
                <Row>
                    {chamados.map(c => (
                        <Col md={4} key={c.id_chamado} className="mb-3">
                            <Card className="shadow-sm border-0 h-100" onClick={() => abrirDetalhes(c)} style={{ cursor: 'pointer' }}>
                                <div style={{ height: '6px', borderTopLeftRadius: '12px', borderTopRightRadius: '12px', backgroundColor: c.cor_hex || c.COR_HEX || '#0dcaf0' }} />
                                <Card.Body>
                                    <div className="d-flex justify-content-between mb-2">
                                        <Badge bg="secondary">Loja {String(c.loja).padStart(2, '0')}</Badge>
                                        <Badge style={{ backgroundColor: c.cor_hex || c.COR_HEX || '#0dcaf0' }}>{c.status_nome || c.STATUS_NOME}
                                            {c.nota_avaliacao > 0 & c.status === 99 ? (
                                                <span>
                                                    <b> - Nota: </b>
                                                    {c.nota_avaliacao || c.NOTA_AVALIACAO}
                                                </span>
                                            ) : null}
                                        </Badge>
                                        <div className="text-muted small">#{c.id_chamado || c.ID_CHAMADO}</div>
                                    </div>

                                    <Card.Title className="h6 fw-bold">{c.assunto}</Card.Title>
                                    <Card.Text className="small text-muted mb-0">Solicitante: {formatarNomePrimeiro(c.nome_usuario)}</Card.Text>
                                    <Card.Text className="small text-muted">Categoria: {c.nome_categoria || c.categoria_nome}</Card.Text>
                                    <div className="small text-primary fw-bold mt-2">
                                        {formatarData(c.data_abertura)}
                                    </div>
                                    <Card.Text className="small text-muted text-truncate">{decodeBase64(c.descricao || c.DESCRICAO)}</Card.Text>

                                    {c.ultima_data_interacao && (
                                        <div style={{ fontSize: '0.75rem', color: '#666', marginTop: '5px' }}>
                                            <i className="bi bi-reply-all me-1"></i>
                                            <b>Última resposta: </b>{formatarData(c.ultima_data_interacao)} - <b>Usuário: </b>{formatarNomePrimeiro(c.ultima_nome_interacao)}
                                        </div>
                                    )}
                                    {(c.USUARIO_ATENDENDO || c.usuario_atendendo) && (c.dp_setor === 'T' || c.dp_setor === 'T') && (
                                        <div className="mt-2">
                                            <Badge bg="warning" text="dark" className="w-100 p-2 d-flex align-items-center justify-content-center">
                                                <i className="bi bi-person-fill me-1"></i>
                                                Sendo atendido por: {formatarNomePrimeiro(c.nome_atendendo || c.nome_atendendo).split(' ')[0]}
                                            </Badge>
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>

                {/* 3. Spinner de rodapé: aparece abaixo da lista enquanto carrega a próxima página */}
                {loading && chamados.length > 0 && (
                    <div className="text-center my-3">
                        <Spinner animation="border" size="sm" variant="primary" className="me-2" />
                        <span className="text-muted small">Carregando mais...</span>
                    </div>
                )}
                {/*{loading ? <div className="text-center mt-5"><Spinner animation="border" /></div> : (
                    <Row>
                        {chamados.map(c => (
                            <Col md={4} key={c.id_chamado} className="mb-3">
                                <Card className="shadow-sm border-0 h-100" onClick={() => abrirDetalhes(c)} style={{ cursor: 'pointer' }}>
                                    <div style={{ height: '6px', borderTopLeftRadius: '12px', borderTopRightRadius: '12px', backgroundColor: c.cor_hex || c.COR_HEX || '#0dcaf0' }} />
                                    <Card.Body>
                                        <div className="d-flex justify-content-between mb-2">
                                            <Badge bg="secondary">Loja {String(c.loja).padStart(2, '0')}</Badge>
                                            <Badge style={{ backgroundColor: c.cor_hex || c.COR_HEX || '#0dcaf0' }}>{c.status_nome || c.STATUS_NOME}
                                                {c.nota_avaliacao > 0 & c.status === 99 ? (
                                                    <span>
                                                        <b> - Nota: </b>
                                                        {c.nota_avaliacao || c.NOTA_AVALIACAO}
                                                    </span>
                                                ) : null}
                                            </Badge>
                                            <div className="text-muted small">#{c.id_chamado || c.ID_CHAMADO}</div>
                                        </div>

                                        <Card.Title className="h6 fw-bold">{c.assunto}</Card.Title>
                                        <Card.Text className="small text-muted mb-0">Solicitante: {formatarNomePrimeiro(c.nome_usuario)}</Card.Text>
                                        <Card.Text className="small text-muted">Categoria: {c.nome_categoria || c.categoria_nome}</Card.Text>
                                        <div className="small text-primary fw-bold mt-2">
                                            {formatarData(c.data_abertura)}
                                        </div>
                                        <Card.Text className="small text-muted text-truncate">{decodeBase64(c.descricao || c.DESCRICAO)}</Card.Text>

                                        {c.ultima_data_interacao && (
                                            <div style={{ fontSize: '0.75rem', color: '#666', marginTop: '5px' }}>
                                                <i className="bi bi-reply-all me-1"></i>
                                                <b>Última resposta: </b>{formatarData(c.ultima_data_interacao)} - <b>Usuário: </b>{formatarNomePrimeiro(c.ultima_nome_interacao)}
                                            </div>
                                        )}
                                        {(c.USUARIO_ATENDENDO || c.usuario_atendendo) && (c.dp_setor === 'T' || c.dp_setor === 'T') && (
                                            <div className="mt-2">
                                                <Badge bg="warning" text="dark" className="w-100 p-2 d-flex align-items-center justify-content-center">
                                                    <i className="bi bi-person-fill me-1"></i>
                                                    Sendo atendido por: {formatarNomePrimeiro(c.nome_atendendo || c.nome_atendendo).split(' ')[0]}
                                                </Badge>
                                            </div>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )}
                */}
                {temMais && (
                    <div className="d-flex justify-content-center my-4">
                        <Button
                            variant="outline-primary"
                            onClick={() => carregarChamados(pagina + 1)}
                            disabled={loading}
                        >
                            {loading ? (
                                <><Spinner size="sm" className="me-2" /> Carregando...</>
                            ) : (
                                "Carregar mais chamados"
                            )}
                        </Button>
                    </div>
                )}
            </Container>

            <Modal show={showDetalhes} onHide={() => setShowDetalhes(false)} size="lg" centered>
                <Modal.Header closeButton className="bg-dark text-white">
                    <Modal.Title className="h6">Chamado #{chamadoSelecionado?.id_chamado || chamadoSelecionado?.ID_CHAMADO} - {chamadoSelecionado?.assunto || chamadoSelecionado?.ASSUNTO}</Modal.Title>
                </Modal.Header>
                <div style={{ height: '6px', borderTopLeftRadius: '12px', borderTopRightRadius: '12px', backgroundColor: chamadoSelecionado?.cor_hex || chamadoSelecionado?.COR_HEX || '#0dcaf0' }} />

                <Modal.Body style={{ backgroundColor: '#e5ddd5', maxHeight: '60vh', overflowY: 'auto' }}>
                    {loadingDetalhes ? <div className="text-center p-4"><Spinner animation="border" /></div> : (
                        <>
                            {/* CABEÇALHO COM INFORMAÇÕES DETALHADAS */}
                            <div
                                id="chat-container"
                                ref={chatContainerRef} // <-- Adicione esta linha
                                style={{
                                    maxHeight: '450px',
                                    overflowY: 'auto',
                                    padding: '10px',
                                    backgroundColor: '#e5ddd5'
                                }}
                            >
                                <div className="bg-light p-3 rounded mb-3 shadow-sm border-start border-4 border-primary">
                                    <Row className="g-2">
                                        <Col xs={6}>
                                            <small className="text-muted d-block">Usuário Solicitante:</small>
                                            <span className="fw-bold">{formatarNomePrimeiro(chamadoSelecionado?.nome_usuario)}</span>
                                        </Col>
                                        <Col xs={6} className="text-end">
                                            <small className="text-muted d-block">Abertura:</small>
                                            <span className="fw-bold">{formatarData(chamadoSelecionado?.data_abertura)}</span>
                                        </Col>
                                        <Col xs={12}>
                                            <small className="text-muted d-block">Categoria Registrada (Técnico pode alterar):</small>
                                            <Form.Select
                                                size="sm"
                                                className="fw-bold text-primary"
                                                value={chamadoSelecionado?.id_categoria}
                                                disabled={
                                                    modoSomenteLeitura || atualizandoCategoria ||
                                                    (chamadoSelecionado?.dp_setor?.toUpperCase() !== "T" && chamadoSelecionado?.DP_SETOR?.toUpperCase() !== "T")
                                                }
                                                onChange={(e) => {
                                                    const label = e.target.options[e.target.selectedIndex].text;
                                                    alterarCategoria(e.target.value, label);
                                                }}
                                            >
                                                {categoriasSetor.map((cat, idx) => (
                                                    <option key={idx} value={cat.id_categoria || cat.codigo}>
                                                        {cat.nome_categoria || cat.descricao}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            {atualizandoCategoria && <Spinner size="sm" className="mt-1" />}
                                        </Col>
                                    </Row>
                                </div>


                                <div className="bg-white p-3 rounded mb-3 shadow-sm">
                                    <small className="text-muted fw-bold">Descrição Inicial:</small>
                                    <p className="mb-0">{decodeBase64(chamadoSelecionado?.descricao || "")}</p>
                                    {anexosAbertura.length > 0 && renderAnexos(anexosAbertura)}
                                </div>

                                {/* MAP DE INTERAÇÕES ESTILO WHATSAPP */}
                                {interacoes.map((int, i) => {
                                    // Lógica principal: Se eu enviei (USUARIO === chapa), vai para a direita
                                    const souEu = String(int.USUARIO || int.usuario) === String(chapa);

                                    return (
                                        <div
                                            key={i}
                                            className={`d-flex mb-3 ${souEu ? 'justify-content-end' : 'justify-content-start'}`}
                                        >
                                            <div
                                                className="position-relative"
                                                style={{
                                                    borderRadius: souEu
                                                        ? '12px 12px 4px 12px'
                                                        : '12px 12px 12px 4px',
                                                    backgroundColor: souEu ? '#dcf8c6' : '#ffffff',
                                                    maxWidth: '65%',
                                                    padding: '6px 8px',
                                                    boxShadow: '0 1px 1px rgba(0,0,0,0.08)',
                                                    display: 'inline-block'
                                                }}
                                            >
                                                {/* Nome do remetente (apenas se não for eu) */}
                                                {souEu && (
                                                    <span className={`fw-bold ${souEu ? 'text-success' : 'text-primary'}`}>
                                                        Você
                                                    </span>
                                                )}
                                                {!souEu && (
                                                    <small className="d-block fw-bold mb-1" style={{ fontSize: '11px', color: '#075E54' }}>
                                                        {formatarNomePrimeiro(int.nome_usuario)}
                                                    </small>
                                                )}

                                                <div style={{ wordBreak: 'break-word', fontSize: '14px' }}>
                                                    {decodeBase64(int.mensagem)}
                                                </div>

                                                {/* Renderização de Anexos dentro do balão */}
                                                {int.ANEXOS && int.ANEXOS.length > 0 && (
                                                    <div className="mt-2 border-top pt-1">
                                                        {renderAnexos(int.ANEXOS)}
                                                    </div>
                                                )}

                                                {/* Hora da mensagem */}
                                                <small

                                                    className={`d-block text-end mt-1 ${souEu ? 'text-muted' : 'text-muted'}`}
                                                    style={{ fontSize: '10px' }}
                                                >
                                                    {(int.descricao)} -  {formatarData(int.data_interacao)}
                                                </small>
                                                {chamadoSelecionado?.nota_avaliacao > 0 & int.status_novo === 99 ? (
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <Badge style={{ backgroundColor: chamadoSelecionado?.cor_hex || chamadoSelecionado?.COR_HEX || '#0dcaf0' }}><b>Nota: </b>{chamadoSelecionado?.nota_avaliacao}</Badge>

                                                    </div>
                                                ) : ""}

                                                {/* "Rabicho" do balão (Opcional - Efeito visual) */}
                                                <div style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    [souEu ? 'right' : 'left']: '-8px',
                                                    width: '0',
                                                    height: '0',
                                                    borderTop: `10px solid ${souEu ? '#198754' : '#fff'}`,
                                                    borderLeft: souEu ? '10px solid transparent' : 'none',
                                                    borderRight: !souEu ? '10px solid transparent' : 'none',
                                                }}></div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    )}
                </Modal.Body>

                <Modal.Footer className="d-block bg-light">
                    {chamadoSelecionado?.dp_setor !== "X" ? (
                        <>
                            {/* Se for leitura, mostra um aviso. Se não, mostra os controles */}
                            {modoSomenteLeitura ? (
                                <div className="alert alert-info py-2 px-3 mb-0 small d-flex align-items-center">
                                    <i className="bi bi-info-circle-fill me-2"></i>
                                    Você está visualizando este chamado em &nbsp;<strong> modo de consulta</strong>.
                                </div>
                            ) : (
                                <>
                                    {/* 1. SELETOR DE STATUS */}
                                    {chamadoSelecionado?.dp_setor === "T" && (
                                        <div className="mb-2 w-100">
                                            <Form.Select
                                                className="fw-bold shadow-sm"
                                                value={statusSelecionado || ""}
                                                onChange={(e) => setStatusSelecionado(Number(e.target.value))}
                                            >
                                                <option value="">Alterar Status / Finalizar...</option>
                                                {statusSetor.map((st, idx) => (
                                                    <option key={idx} value={st.id_status}>
                                                        {st.descricao}
                                                    </option>
                                                ))}
                                                <option value={90}>RESOLVIDO</option>
                                            </Form.Select>
                                        </div>
                                    )}

                                    {/* 2. MINIATURAS DOS ANEXOS */}
                                    {anexosNovos.length > 0 && (
                                        <div className="d-flex gap-2 mb-2">
                                            {anexosNovos.map((file, index) => (
                                                <Badge key={index} bg="info" className="d-flex align-items-center p-2">
                                                    <i className="bi bi-paperclip me-1"></i>
                                                    {file.name || file.nome || `Arquivo ${index + 1}`}
                                                    <i className="bi bi-x-circle ms-2" style={{ cursor: 'pointer' }} onClick={() => removerAnexo(index)}></i>
                                                </Badge>
                                            ))}
                                        </div>
                                    )}

                                    {/* 3. BARRA DE MENSAGEM */}
                                    <InputGroup className="shadow-sm border rounded-3 overflow-hidden">
                                        <input type="file" id="fileAtend" hidden multiple onChange={handleFileChange} accept="image/*,application/pdf" />
                                        <Button
                                            variant="light"
                                            className="bg-white border-0 px-2 px-md-3"
                                            onClick={() => document.getElementById('fileAtend').click()}
                                        >
                                            <i className="bi bi-paperclip fs-5 text-secondary"></i>
                                        </Button>

                                        {/*<Form.Control
                                            className="border-0 shadow-none py-2"
                                            style={{ fontSize: '16px', flex: '1' }}
                                            placeholder="Digite sua mensagem..."
                                            value={novaMsg}
                                            onChange={(e) => setNovaMsg(e.target.value)}
                                            onKeyPress={(e) => e.key === 'Enter' && handleSubmitInteracao()}
                                        />*/}
                                        <Form.Control
                                            className="border-0 shadow-none py-2"
                                            style={{ fontSize: '16px', flex: '1' }}
                                            placeholder="Digite sua mensagem..."
                                            value={novaMsg}
                                            onChange={(e) => setNovaMsg(e.target.value)}
                                            onKeyPress={(e) => e.key === 'Enter' && handleSubmitInteracao()}
                                            onPaste={handlePaste} // 🔥 AQUI
                                        />

                                        <Button
                                            variant="primary"
                                            className="px-2 px-md-4 border-0 d-flex align-items-center justify-content-center"
                                            onClick={handleSubmitInteracao}
                                            disabled={enviandoInt}
                                        >
                                            {enviandoInt ? <Spinner size="sm" /> : <i className="bi bi-send-fill"></i>}
                                        </Button>
                                    </InputGroup>
                                </>
                            )}
                        </>
                    ) : (
                        <div className="text-center py-2 text-muted small fw-bold">
                            <i className="bi bi-lock-fill me-1"></i> {chamadoSelecionado?.status_nome}.<br /> Novas interações desativadas.
                        </div>
                    )}
                </Modal.Footer>
            </Modal>

            {/* Modais de visualização */}
            <Foto
                show={!!fotoSelecionada}
                onClose={() => setFotoSelecionada(null)}
                foto={fotoSelecionada?.foto}
                nome={fotoSelecionada?.nome}
                info01=""
                info02=""
            />

            {/* MODAL PDF */}
            <Modal
                show={!!pdfSelecionado}
                onHide={() => {
                    setPdfSelecionado(null);
                    setFullscreenPdf(false);
                }}
                size="lg"
            >
                <Modal.Header closeButton className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center" style={{ minWidth: 0, flex: 1 }}>
                        <strong
                            className="text-primary text-truncate"
                            style={{
                                fontSize: '0.9rem',
                                maxWidth: '100%',
                                display: 'block'
                            }}
                            title={pdfSelecionado?.nome}
                        >
                            {pdfSelecionado?.nome}
                        </strong>
                    </div>

                    <Button
                        variant="outline-primary"
                        size="sm"
                        className="ms-2 flex-shrink-0"
                        onClick={() => setFullscreenPdf(true)}
                        style={{ fontSize: '0.8rem', whiteSpace: 'nowrap' }}
                    >
                        <i className="bi bi-arrows-fullscreen"></i>
                        <span className="d-none d-md-inline ms-1">Fullscreen</span>
                    </Button>
                </Modal.Header>

                <Modal.Body style={{ height: '75vh', p: 0, display: 'flex', flexDirection: 'column' }}>
                    {urlParaVisualizar ? (
                        <>
                            {/* Barra de ferramentas com botão de Download */}
                            <div className="d-flex justify-content-end p-2 bg-light border-bottom">
                                <Button
                                    variant="primary"
                                    size="sm"
                                    onClick={() => {
                                        const link = document.createElement('a');
                                        link.href = urlParaVisualizar;
                                        link.download = pdfSelecionado?.nome || "arquivo";
                                        link.click();
                                    }}
                                >
                                    <i className="bi bi-download"></i> Baixar Arquivo
                                </Button>
                            </div>

                            <iframe
                                src={urlParaVisualizar} // 🔥 IMPORTANTE: Use a URL do Blob
                                width="100%"
                                height="100%"
                                style={{ border: 'none' }}
                                title="Visualizador"
                            />
                        </>
                    ) : (
                        <div className="text-center p-5">Carregando visualização...</div>
                    )}
                </Modal.Body>
            </Modal>

            <PdfFullscreen
                pdf={urlParaVisualizar} // 🔥 Agora vai a URL do Blob (com tipo certo)
                nome={pdfSelecionado?.nome}
                fullscreen={fullscreenPdf}
                setFullscreen={setFullscreenPdf}
            />

            {setorSelecionado && (
                <div
                    style={{
                        position: 'fixed',
                        bottom: '40px', // Acima do footer
                        right: '20px',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Fundo preto transparente
                        color: '#fff',
                        padding: '5px 12px',
                        borderRadius: '20px',
                        fontSize: '0.75rem',
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        backdropFilter: 'blur(4px)' // Efeito de vidro embaçado
                    }}
                >
                    <Spinner
                        animation="border"
                        size="sm"
                        className="me-2"
                        style={{ width: '12px', height: '12px', borderWidth: '2px' }}
                    />
                    Atualizando em: {Math.floor(segundosParaAtualizar / 60)}:
                    {String(segundosParaAtualizar % 60).padStart(2, '0')}
                </div>
            )}

            <Footer />
        </div>
    );
}

export default AtendimentoTecnico;